import { Component, Input } from '@angular/core';

import { ToolbarEvent } from '../../core/events/toolbar.event';
import { customButtonList } from '../config';
import { List } from 'linqts';

@Component({
    selector: 'ixs-toolbar',
    templateUrl: 'toolbar.component.html',
    // styleUrls: ['toolbar.scss']

})
export class ToolbarComponent {

    @Input()
    showButtonList: boolean = false;

    @Input()
    showAdd: Boolean;
    @Input()
    showDelete: Boolean;

    private groups: any = [];

    private data: [customButtonList];

    @Input()

    set customButtonList(value: any) {

        this.data = value;
        this.loadData();
    }
    get customButtonList() {
        return this.data;
    }

    constructor(public toolbarEvent: ToolbarEvent) {

    }

    async ngAfterViewInit() {

        await this.loadData();

    }

    private async loadData() {

        if (this.data) {

            this.groups = new List<customButtonList>(this.data)
            .Select(o => o.grpname === "" ||o.grpname === null || o.grpname === undefined ?  "Options" : o.grpname  )
            .Distinct()
            .ToArray();


        }
    }

    filterData(grp): Array<customButtonList> {
        if (grp === "Options"){
            grp = undefined;
           return this.data.filter(o => o.grpname === grp);
       }

        else{
            return this.data.filter(o => o.grpname === grp);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/toolbar/toolbar.component.ts